/* istanbul ignore file */
import React from 'react';
import ContactsBreadcrumbs from 'domain/sales/contact/shared/ContactsBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateContactBreadcrumbs = () => (
  <ContactsBreadcrumbs>
    <CreateBreadcrumbItem entity="Contact" />
  </ContactsBreadcrumbs>
);

export default CreateContactBreadcrumbs;
